webpackJsonp([44353235307851],{

/***/ 628:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/a-le-coq.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"August 30, 2026","title":"A. Le Coq ","videoUrl":"https://vimeo.com/899158259?share=copy&fl=sv&fe=ci","image":"/img/alekokk.jpg","credits":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/a-le-coq.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-a-le-coq-a429eca5a178393f600f.js